import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaExternalLinkAlt } from "react-icons/fa";
import "./EditorialSection.css";

export function SectionHeader({ eyebrow, title, description, id, action }) {
  return (
    <div className="editorial-header">
      {eyebrow ? <span className="editorial-eyebrow">{eyebrow}</span> : null}
      <div className="editorial-header-row">
        <div>
          <h2 id={id}>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {action ? action : null}
      </div>
    </div>
  );
}

export function ActionLink({ children, to, external = false }) {
  const content = (
    <>
      <span>{children}</span>
      {external ? <FaExternalLinkAlt aria-hidden="true" /> : <FaArrowRight aria-hidden="true" />}
    </>
  );

  return external ? (
    <a className="editorial-action" href={to} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  ) : (
    <Link className="editorial-action" to={to}>
      {content}
    </Link>
  );
}

export function EditorialSection({ children, id, tone = "light", className = "", style }) {
  return (
    <section className={`editorial-section editorial-section-${tone} ${className}`.trim()} id={id} style={style}>
      <div className="editorial-shell">{children}</div>
    </section>
  );
}
